<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.studentUpdateRecordList.push"
    :is-show-administrator-select="true"
    :is-show-student-update-type-select="true"
    :is-show-search-input="true"
    administrator-select-label="操作账号"
    student-update-type-select-label="单次修改包含的项目"
    :is-show-xls-export-button="true"
    :show-summary="true"
    excel-name="学员个人资料修改记录"
    :excel-data="xlsData"
  >
    <v-column-time value="操作时间"/>

    <el-table-column label="操作账号" width="140" align="">
      <template v-slot="{ row }">
        <v-avatar-nickname
          v-if="row.administrator_id"
          :value="row.administrator_avatar"
          :nickname="row.administrator_nickname"
          :is-center="false"
          :avatar-size="50"
        />
        <router-link v-else :to="RouteConfig.studentDetail.to(row.student_id)" class="primary-color">学员本人</router-link>
      </template>
    </el-table-column>

    <el-table-column label="操作类型" width="110">
      <template v-slot="{ row }">
        修改{{ findStudentUpdateType(row.update_type)[0].name }}
      </template>
    </el-table-column>
    <el-table-column label="学员ID" width="100">
      <template v-slot="{ row }">
        <router-link :to="RouteConfig.studentDetail.to(row.student_id)" class="primary-color">{{ row.student_id }}</router-link>
      </template>
    </el-table-column>

    <el-table-column label="学员当前头像" width="110">
      <template v-slot="{ row }">
        <v-avatar :value="row.selfie_current" :size="50"/>
      </template>
    </el-table-column>

    <el-table-column label="学员当前姓名" width="110">
      <template v-slot="{ row }">
        {{ row.student_name_current }}
      </template>
    </el-table-column>


    <el-table-column label="姓名记录">
      <template v-slot="{ row }">
        <template v-if="row.old_student_name !== row.student_name">
          「<span v-if="row.old_student_name" class="primary-color user-select">{{ row.old_student_name }}</span><span v-else class="hint-color">无</span>」改为「<span v-if="row.student_name" class="success-color user-select">{{row.student_name}}</span><span v-else class="hint-color">无</span>」
        </template>
        <span v-else class="hint-color">未修改</span>

      </template>
    </el-table-column>

    <el-table-column label="手机号记录" width="290">
      <template v-slot="{ row }">

        <template v-if="row.old_phone !== row.phone">
          「<span v-if="row.old_phone" class="primary-color user-select">{{ row.old_phone }}</span><span v-else class="hint-color">无</span>」改为「<span v-if="row.phone" class="success-color user-select">{{ row.phone }}</span><span v-else class="hint-color">无</span>」
        </template>
        <span v-else class="hint-color">未修改</span>

      </template>
    </el-table-column>

    <el-table-column label="会员号记录">
      <template v-slot="{ row }">

        <template v-if="row.old_card_number !== row.card_number && (row.old_card_number || row.card_number)">
          「<span v-if="row.old_card_number" class="primary-color user-select">{{ row.old_card_number }}</span><span v-else class="hint-color">无</span>」改为「<span v-if="row.card_number" class="success-color user-select">{{row.card_number}}</span><span v-else class="hint-color">无</span>」
        </template>
        <span v-else class="hint-color">未修改</span>

      </template>
    </el-table-column>

    <el-table-column label="账户内总课卡数量（张）" prop="card_count"/>

    <el-table-column label="账户内总办卡金额（元）" prop="actual_payment" type="money">
      <template v-slot="{ row }">
        {{ row.actual_payment | toYuan }}
      </template>
    </el-table-column>

    <el-table-column label="操作">
      <template v-slot="{ row }">
        <v-list-button icon="view" name="查看" :to="RouteConfig.studentUpdateRecordDetail.to(row.id)"/>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >

            <div class="list-item-detail">
              <span>操作时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>操作管理员</span>

              <v-avatar-nickname
                v-if="v.administrator_id"
                :value="v.administrator_avatar"
                :nickname="v.administrator_nickname"
                :is-center="false"
                :avatar-size="50"
                width="30vw"
              />
              <router-link v-else :to="RouteConfig.studentDetail.to(v.student_id)" class="primary-color">学员本人</router-link>
            </div>

            <div class="list-item-detail">
              <span>操作类型</span>
              修改{{ findStudentUpdateType(v.update_type)[0].name }}
            </div>

            <div class="list-item-detail">
              <span>学员ID</span>
              <router-link :to="RouteConfig.studentDetail.to(v.student_id)" class="primary-color">{{ v.student_id }}</router-link>
            </div>

            <div class="list-item-detail">
              <span>学员当前头像</span>
              <v-avatar :value="v.selfie_current" :size="50"/>
            </div>

            <div class="list-item-detail">
              <span>学员当前姓名</span>
              <span>{{ v.student_name_current }}</span>
            </div>

            <div class="list-item-detail">
              <span>姓名记录</span>
              <span>
                <template v-if="v.old_student_name !== v.student_name">
                  「<span v-if="v.old_student_name" class="primary-color user-select">{{ v.old_student_name }}</span><span v-else class="hint-color">无</span>」改为「<span v-if="v.student_name" class="success-color user-select">{{ v.student_name }}</span><span v-else class="hint-color">无</span>」
                </template>
                <span v-else class="hint-color">未修改</span>
              </span>
            </div>

            <div class="list-item-detail">
              <span>手机号记录</span>
              <span>
                <template v-if="v.old_phone !== v.phone">
                  「<span v-if="v.old_phone" class="primary-color user-select">{{ v.old_phone }}</span><span v-else class="hint-color">无</span>」改为「<span v-if="v.phone" class="success-color user-select">{{ v.phone }}</span><span v-else class="hint-color">无</span>」
                </template>
                <span v-else class="hint-color">未修改</span>
              </span>
            </div>

            <div class="list-item-detail">
              <span>会员号记录</span>
              <span>
                <template v-if="v.old_card_number !== v.card_number && (v.old_card_number || v.card_number)">
                「<span v-if="v.old_card_number" class="primary-color user-select">{{ v.old_card_number }}</span><span v-else class="hint-color">无</span>」改为「<span v-if="v.card_number" class="success-color user-select">{{v.card_number}}</span><span v-else class="hint-color">无</span>」
                </template>
                <span v-else class="hint-color">未修改</span>
              </span>
            </div>

            <div class="list-item-detail">
              <span>账户内总课卡数量（张）</span>
              <span>{{ v.card_count }}</span>
            </div>

            <div class="list-item-detail">
              <span>账户内总办卡金额（元）</span>
              <span>{{ v.actual_payment | toYuan }}</span>
            </div>

            <div class="list-item-button">
              <v-list-button
                name="查看"
                icon="view"
                :isLast="true"
                :to="RouteConfig.studentUpdateRecordDetail.to(v.id)"
              />
            </div>
          </div>

          <div class="list-item list-count-box primary-background-light">
            <div class="list-item-detail">
              <strong>本页合计</strong>
            </div>
            <div class="list-item-detail">
              <span>账户内总办卡金额</span>
              <span class="income-count">{{ actual_payment | toYuan }} 元</span>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>

</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index } from '@/api/student-update-record';
import { timeToYmdHi, toYuan, plus } from "@/filters";
import { findStudentUpdateType } from "@/enums/studentUpdateTypes";

export default {
  name: RouteConfig.studentUpdateRecordList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isStoringIds: [],
    isDeleting: {},
    count: 0,
    list: [],
    xlsData: [],
    actual_payment: 0,
    queryList: {},
  }),
  computed: {
    ...mapGetters([
      'defaultStoreId',
      'isAdministrator',
      'isMobile',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findStudentUpdateType,
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      const xlsData = [];
      let actual_payment = 0;
      data.list.forEach(item => {
        actual_payment = plus(actual_payment, item.actual_payment);
        xlsData.push({
          '学员ID': item.student_id,
          '学员姓名（旧）': item.old_student_name,
          '学员姓名（新）': item.student_name,
          '手机号（旧）': item.old_phone,
          '手机号（新）': item.phone,
          '会员号（旧）': item.old_card_number,
          '会员号（新）': item.card_number,
          '账户内总课卡数量（张）': toYuan(item.actual_payment),
          '账户内总办卡金额（元）': toYuan(item.actual_payment),
          '更改资料日期': timeToYmdHi(item.add_time),
          '操作账号': item.administrator_nickname,
        });
      });
      this.count = data.count;
      this.list = data.list;
      this.xlsData = xlsData;
      this.actual_payment = actual_payment;
      if (next) next();
    },
  },
};
</script>
